import { sortBy } from "parog-web/utils/sort";
import BaseDialysisSessionDeclaredModelView, {
  type DialysisMeasured
} from "./dialysis-session-declared-model-view";
import HemodialysisMeasuredJournalEvent from "./hemodialysis-measured-journal-event";

/**
 * Hemodialysis-specific implementation of BaseDialysisSessionDeclaredModelView.
 *
 * This class generates a model used by the Hemodialysis::SessionMeasurement view.
 *
 */
export default class HemodialysisSessionDeclaredModelView extends BaseDialysisSessionDeclaredModelView<HemodialysisMeasuredJournalEvent> {
  protected sessionKey = "hemodialysisSessionDeclaredJournalEvent";

  completedArrayWithMissingMeasurements({
    measures,
    moment
  }: {
    measures: DialysisMeasured[];
    moment: string;
  }): HemodialysisMeasuredJournalEvent[] {
    const everyMeasurements = [...measures.sort(sortBy("occurredAt"))];

    // Each start/end array should have 1 measurement and
    // middle array should have 20 measurements
    const expectedCount = moment === "middle" ? 20 : 1;

    const occurredAt = moment === "start" ? this.session.occurredAt : undefined;

    while (everyMeasurements.length < expectedCount) {
      everyMeasurements.push(
        this.store.createRecord("hemodialysis-measured-journal-event", {
          moment,
          occurredAt
        })
      );
    }

    return everyMeasurements as HemodialysisMeasuredJournalEvent[];
  }

  async validate(): Promise<boolean> {
    this.normalizedChangesets = this.measureOccurredAtChangesets(
      this.allUsedChangesets
    );

    await Promise.all([
      ...this.normalizedChangesets.map(changeset => changeset.validate()),
      this.sessionChangeset.validate()
    ]);

    this.validateOccurredAtTimeAgainstPrevious(this.allChangesets);
    this.validateOccurredAtTimePrecense(this.normalizedChangesets);

    return [...this.normalizedChangesets, this.sessionChangeset].every(
      changeset => changeset.isValid
    );
  }

  protected override getChangesetsForSave() {
    return (
      this.normalizedChangesets ??
      this.measureOccurredAtChangesets(this.allUsedChangesets)
    );
  }

  protected measurementValidations() {
    return HemodialysisMeasuredJournalEvent.validations(this.intl);
  }
}
